export default function setProductTabs() {
  const tabsWrapper = document.querySelector('[data-product-tabs]');

  if (tabsWrapper) {
    const buttons = tabsWrapper.querySelectorAll('.tab-button');
    const panes = tabsWrapper.querySelectorAll('.tab-pane');

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const target = btn.getAttribute('data-tab-target');

        buttons.forEach((b) => b.classList.remove('-active'));
        panes.forEach((p) => p.classList.remove('-active'));

        btn.classList.add('-active');

        const targetPane = tabsWrapper.querySelector(`#${target}`);
        if (targetPane) {
          targetPane.classList.add('-active');
        }
      });
    });
  }
}
